<template>
  <div class="rank-list-row" :class="rank == index ? 'current' : ''" v-if="item && item.user && item.user.nickname" :key="'rank-'+index">
    <div class="rank-list-column-1">
      <img
        :src="OSS_BASE + '/market/img/rank/0' + index + '.png'"
        class="rank-list-column-image"
        v-if="index<4"
      />
      <span class="rank-index" v-else>{{index}}</span>
    </div>
    <div class="rank-list-column-2">
      {{ item && item.user && item.user.nickname ? item.user.nickname : "" }}
    </div>
    <div class="rank-list-column-3 times">
      {{ item && item.score ? item.score + "s" : "" }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "item", "rank"],
  data() {
    return {
      OSS_BASE,
    };
  },
  created() {
    console.log(this.item, this.index, this.rank);
  },
  methods: {},
};
</script>

<style>
.rank-list-row {
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #fff;
  background: #4d38a1;
  position: relative;
  z-index: 1;
}
.rank-list-row:first-child {
  border-radius: 4px 4px 0 0;
}
.rank-list-row:nth-child(2n) {
  background: #211158;
}
.rank-list-row.current {
  z-index: 2;
}
.rank-list-row.current::after {
  background: #6e57e5;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 105%;
  height: 100%;
  border-radius: 4px;
  z-index: -1;
}
.rank-list-column-1,
.rank-list-column-2,
.rank-list-column-3 {
  font-size: 14px;
  /* padding-left: 8px; */
  padding: 12px 0 12px 12px;
  box-sizing: border-box;
}
.rank-list-column-1 {
  width: 22.5%;
  text-align: center;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rank-index {
  color: #fff;
}
.rank-list-column-2 {
  width: 56.5%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.rank-list-column-3 {
  width: 21.1%;
}
.rank-list-column-3.times {
  color: #ffd75b;
}
.rank-list-column-image {
  width: 30%;
  display: block;
  margin: 0 auto;
}
@media screen and (max-width: 414px) {
  /* .rank-list-row {
    display: none;
  } */
  .rank-top-time {
    top: 63%;
  }
  .rank-top-card-center .rank-top-time {
    top: 64%;
  }
  /* .rank-list-row.current::after {
    display: none;
  } */
  .narrow .rank-list-row,
  .rank-list-row.title,
  .rank-list-row.current {
    display: flex;
  }
  .narrow .rank-list-row.current::after {
    display: block;
  }
    .rank-list-column-1,
.rank-list-column-2,
.rank-list-column-3 {
  font-size: 12px;
    padding: 8px 0 8px 8px;}
  .rank-list-column-1 {
    padding: 8px;
  }
  .rule-title{
    font-size: 12px;
  }
  .rule-desc{
    font-size: 10px;
  }
}
@media screen and(max-width:413px) {
  .rank-top-time {
    /* top: 62%; */
    font-size: 14px;
  }
      .rank-list-column-1,
.rank-list-column-2,
.rank-list-column-3 {
  font-size: 10px;
    padding: 6px 0 6px 8px;}
  .rank-list-column-1 {
    padding:6px 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/maze/rankItem.vue